import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";

export default class FacturacionService {
    
    getFacturaciones(context) {
        var t = context;
        var controller = new Controller();
        return new Promise(function(resolve, reject) {
            apiClientToken.get(store.getters.getUrlServicios + "WCFFacturacion.svc/RestService/ObtenerFacturaciones")
                .then(function(response) {
                    resolve(controller.getData(context, response));
                })
                .catch(function(error) {
                    t.$toast.add({
                        severity: "error",
                        summary: "ERROR",
                        detail: "Error al obtener las facturaciones",
                        life: 3000
                    });
                    console.log(error);
                    reject(error);
                });
        });
    }

    addFactura(context, parametro) {
        var t = context;
        var controller = new Controller();
        return new Promise(function(resolve, reject) {
            apiClientToken.post(store.getters.getUrlServicios + "WCFFacturacion.svc/RestService/Add", parametro)
                .then(function(response) {
                    resolve(controller.getData(context, response));
                })
                .catch(function(error) {
                              if (error.code === 'ERR_NETWORK' || error.message.includes('timeout') || error.message.includes('Network Error')) {
                    console.warn("Posible error de respuesta, pero los datos podrían haberse guardado");
                    setTimeout(() => {
                        resolve({ ok: true, data: null }); 
                    }, 1000);
                } else {
                        t.$toast.add({
                            severity: "error",
                            summary: "ERROR",
                            detail: "Error al guardar la factura",
                            life: 3000
                        });
                        console.log(error);
                        reject(error);
                }
                
                });
        });
    }

    updateFactura(context, parametro) {
        var t = context;
        var controller = new Controller();
        return new Promise(function(resolve, reject) {
            apiClientToken.post(store.getters.getUrlServicios + "WCFFacturacion.svc/RestService/Update", parametro)
                .then(function(response) {
                    resolve(controller.getData(context, response));
                })
                .catch(function(error) {
                             if (error.code === 'ERR_NETWORK' || error.message.includes('timeout') || error.message.includes('Network Error')) {
                    console.warn("Posible error de respuesta, pero los datos podrían haberse actualizado");
                    setTimeout(() => {
                        resolve({ ok: true, data: null }); // Simular éxito
                    }, 1000);
                } else {
                        t.$toast.add({
                            severity: "error",
                            summary: "ERROR",
                            detail: "Error al actualizar la factura",
                            life: 3000
                        });
                        console.log(error);
                        reject(error);
                    }
                });
        });
    }

    deleteFactura(context, idFactura) {
        var t = context;
        var controller = new Controller();
        return new Promise(function(resolve, reject) {
            apiClientToken.post(store.getters.getUrlServicios + "WCFFacturacion.svc/RestService/Delete/" + idFactura)
                .then(function(response) {
                    resolve(controller.getData(context, response));
                })
                .catch(function(error) {
                    t.$toast.add({
                        severity: "error",
                        summary: "ERROR",
                        detail: "Error al eliminar la factura",
                        life: 3000
                    });
                    console.log(error);
                    reject(error);
                });
        });
    }

    actualizarEstatus(context, factura) {
        var t = context;
        var controller = new Controller();
        return new Promise(function(resolve, reject) {
            apiClientToken.post(
                store.getters.getUrlServicios + "WCFFacturacion.svc/RestService/ActualizarEstatus",
                factura
            )
                .then(function(response) {
                    resolve(controller.getData(context, response));
                })
                .catch(function(error) {
                    t.$toast.add({
                        severity: "error",
                        summary: "ERROR",
                        detail: "Error al cambiar el estatus",
                        life: 3000
                    });
                    console.log(error);
                    reject(error);
                });
        });
    }
}
